export default __webpack_public_path__ + "static/media/img 900x900.95285136.png";